export function exportLeadsToCSV(leads) {
  const headers = [
    'Company', 'Contact', 'Email', 'Phone', 'Service Type',
    'Lead Source', 'Stage', 'Value (£)', 'Priority', 'Address',
    'Score', 'Created'
  ];
  const rows = leads.map(l => [
    l.company_name, l.contact_name, l.email, l.phone,
    l.service_type, l.lead_source, l.stage, l.estimated_value,
    l.priority, l.address, l.score || '',
    new Date(l.created_at).toLocaleDateString('en-GB')
  ]);
  const csv = [headers, ...rows]
    .map(row => row.map(cell => `"${String(cell || '').replace(/"/g, '""')}"`).join(','))
    .join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `gasflow-leads-${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
